import { MultiString } from "../../../library-js/i18n/MultiString";
import { ActionType } from "./data-types/ActionType";
import { ProductType } from "./data-types/ProductType";
import { TagInfoID } from "./data-types/TagInfo";
import { CreatorID } from "./data-types/CreatorInfo";
import { ProductCategory } from "./data-types/ProductCategory";

export class SerializedProductInfo
{
  id:string;

  category:ProductCategory;
 
  types:ProductType[];
  name:MultiString;
  details:MultiString;

  overlays:string[];

  imagePath:MultiString; 
  tags:(TagInfoID|MultiString)[];

  usePriceLabel:boolean;
  price:[number,number];
  priceLabel:MultiString;  

  link:MultiString;
  
  actionLink:MultiString;
  actionType:ActionType;

  about:MultiString;

  creators:CreatorID[];
  
  available:boolean;

  assets:string[];
}